import { CATEGORIES } from "../../constants/categories";

export default function SelectedDayDetail({ selectedDay, setSelectedDay }) {
  if (!selectedDay || !Array.isArray(selectedDay) || selectedDay.length === 0) return null;

  const dateLabel = new Date(selectedDay[0].date + "T00:00:00").toLocaleDateString("vi-VN", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  const completedN = selectedDay.filter(c => c.completed).length;

  return (
    <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-primary)", borderRadius: "16px", padding: "20px", marginBottom: "20px", animation: "fadeIn 0.2s ease", boxShadow: "var(--card-shadow)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px" }}>
        <div>
          <div style={{ fontSize: "15px", fontWeight: "700", color: "var(--text-primary)" }}>{dateLabel}</div>
          <div style={{ fontSize: "12px", color: "var(--text-muted)", marginTop: "2px" }}>{selectedDay.length} thử thách • {completedN} hoàn thành</div>
        </div>
        <button onClick={() => setSelectedDay(null)}
          style={{ background: "none", border: "1px solid var(--border-primary)", borderRadius: "8px", padding: "6px 14px", color: "var(--text-muted)", cursor: "pointer", fontSize: "12px" }}>
          Đóng
        </button>
      </div>
      {selectedDay.map((item) => {
        const cat = CATEGORIES.find(c => c.id === item.category_id) || CATEGORIES[0];
        return (
          <div key={item.id} style={{ background: "var(--bg-inset)", border: "1px solid var(--border-secondary)", borderRadius: "12px", padding: "14px", marginBottom: "10px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "8px" }}>
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <span style={{ fontSize: "20px" }}>{cat.emoji}</span>
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "600", color: "var(--text-primary)" }}>{item.title}</div>
                  <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "2px" }}>{cat.label} • {item.time_required}</div>
                </div>
              </div>
              <div style={{ background: item.completed ? "#10B98118" : "var(--bg-inset)", color: item.completed ? "#16A34A" : "var(--text-muted)", padding: "3px 8px", borderRadius: "12px", fontSize: "10px", fontWeight: "600", whiteSpace: "nowrap" }}>
                {item.completed ? "✅ Hoàn thành" : "⏳ Chưa làm"}
              </div>
            </div>
            <div style={{ fontSize: "13px", color: "var(--text-secondary)", lineHeight: "1.7", marginBottom: "6px" }}>{item.task}</div>
            {item.reflection && (
              <div style={{ background: "var(--bg-card)", borderRadius: "8px", padding: "10px", marginBottom: "6px" }}>
                <div style={{ fontSize: "10px", color: "var(--text-tertiary)", letterSpacing: "1px", marginBottom: "4px", fontWeight: "600" }}>📝 CẢM NHẬN</div>
                <div style={{ fontSize: "12px", color: "var(--text-secondary)", lineHeight: "1.5" }}>{item.reflection}</div>
              </div>
            )}
            {item.ai_feedback && (
              <div style={{ background: "#7C3AED11", borderRadius: "8px", padding: "10px" }}>
                <div style={{ fontSize: "10px", color: "#7C3AED", letterSpacing: "1px", marginBottom: "4px" }}>💬 PHẢN HỒI AI</div>
                <div style={{ fontSize: "12px", color: "var(--text-secondary)", lineHeight: "1.5", fontStyle: "italic" }}>{item.ai_feedback}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
